// Lightweight PDF generation helpers using jsPDF
// We use dynamic import to avoid loading jsPDF unless needed.

export async function generateProductPdf(product, locale = 'zh-CN') {
  const { jsPDF } = await import('jspdf')
  const doc = new jsPDF({ unit: 'pt', format: 'a4' })

  const title = (product[locale]?.title) || product.en.title
  const desc = (product[locale]?.desc) || product.en.desc

  const margin = 56
  let y = margin

  // Header brand
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(18)
  doc.setTextColor(40, 160, 255)
  doc.text('Future Tech — Product Specification', margin, y)
  y += 28

  // Title
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(28)
  doc.setTextColor(20, 20, 20)
  doc.text(title, margin, y)
  y += 24

  // Divider line
  doc.setDrawColor(0, 194, 255)
  doc.setLineWidth(1)
  doc.line(margin, y, doc.internal.pageSize.getWidth() - margin, y)
  y += 20

  // Description (wrapped)
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(12)
  doc.setTextColor(50, 50, 60)
  const maxWidth = doc.internal.pageSize.getWidth() - margin * 2
  const lines = doc.splitTextToSize(desc, maxWidth)
  doc.text(lines, margin, y)
  y += lines.length * 16 + 10

  // Metadata footer
  const now = new Date()
  const dateStr = now.toLocaleDateString(locale)
  doc.setFontSize(10)
  doc.setTextColor(120)
  doc.text(`Generated: ${dateStr}  •  ID: ${product.id}`, margin, doc.internal.pageSize.getHeight() - margin)

  return doc
}

export async function previewProductPdf(product, locale) {
  const doc = await generateProductPdf(product, locale)
  const blobUrl = doc.output('bloburl')
  // Open in a new tab; most browsers will use built-in PDF viewer
  window.open(blobUrl, '_blank', 'noopener,noreferrer')
}

export async function downloadProductPdf(product, locale) {
  const doc = await generateProductPdf(product, locale)
  const filename = `${product.id}.pdf`
  doc.save(filename)
}
